import React from 'react';
import { IconMenu2 } from '@tabler/icons-react';
import { ThemeToggle } from '../../../components/theme-toggle/theme-toggle';
import { ExchangeRateTicker } from '../../../components/exchange-rate-ticker/exchange-rate-ticker';
import { LanguageSelector } from '../../../components/language-selector/language-selector';
import { AlertsMenu } from '../../../components/alerts-menu/alerts-menu';
import { Avatar } from '../../../components/Avatar/avatar';
import './header.css';

interface HeaderProps {
  onMenuOpen: () => void;
  isMobile: boolean;
  isCompact: boolean;
}

/**
 * Header Layout Component.
 * Acts as the top navigation bar, containing the application branding,
 * global actions (Theme, Language, Alerts), and the mobile menu trigger.
 */
export const Header: React.FC<HeaderProps> = ({ onMenuOpen, isMobile, isCompact }) => (
  <header className={`cb-header${isMobile ? ' cb-header--mobile' : ''}`}>
    {isMobile && (
      <button className="cb-hamburger" onClick={onMenuOpen} aria-label="Open navigation">
        <IconMenu2 size={20} />
      </button>
    )}
    <div className="cb-header__brand">
      <span className="cb-logo cb-logo-main">{isMobile ? 'CB' : 'CORUSCANT BANK'}</span>
      {!isCompact && <ExchangeRateTicker />}
    </div>
    <div className="cb-header__actions">
      <AlertsMenu />
      <LanguageSelector />
      <ThemeToggle />
      <Avatar initials="CB" />
    </div>
  </header>
);
